import { Badge } from '@/components/ui/badge';
import { Eye, Clock, XCircle, FileVideo } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatRelativeTime } from '@/lib/date-utils';

interface VideoStatusBadgeProps {
  status: 'generated' | 'processing' | 'failed' | 'pending';
  viewsCount: number;
  lastViewedAt: string | null;
}

/**
 * VideoStatusBadge - Shows video status with icon and view count
 */
export function VideoStatusBadge({
  status,
  viewsCount,
  lastViewedAt,
}: VideoStatusBadgeProps) {
  const getStatusConfig = () => {
    switch (status) {
      case 'generated':
        return {
          icon: Eye,
          label: `${viewsCount} ${viewsCount === 1 ? 'vista' : 'vistas'}`,
          className: 'bg-green-100 text-green-800 border-green-200',
          tooltip: lastViewedAt ? `Última: ${formatRelativeTime(lastViewedAt)}` : null,
        };
      case 'processing':
        return {
          icon: Clock,
          label: 'Procesando',
          className: 'bg-blue-100 text-blue-800 border-blue-200',
          tooltip: null,
        };
      case 'failed':
        return {
          icon: XCircle,
          label: 'Error',
          className: 'bg-red-100 text-red-800 border-red-200',
          tooltip: null,
        };
      case 'pending':
        return {
          icon: FileVideo,
          label: 'Pendiente',
          className: 'bg-gray-100 text-gray-800 border-gray-200',
          tooltip: null,
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <Badge
      className={cn('border gap-1', config.className)}
      title={config.tooltip || undefined}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}
